<template>
  <div>
    <div v-if="item.uiType === 1">
      <el-input size="mini" v-model="value" @blur="getDataUpdate" :disabled="!item.editable" style="width: 100%;">
      </el-input>
    </div>
    <div v-if="item.uiType === 2">
      <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" placeholder="请输入" size="mini" v-model="value"
        :disabled="!item.editable" @blur="getDataUpdate" style="width: 100%;"></el-input>
    </div>
    <div v-if="item.uiType === 7">
      <el-input size="mini" v-model="value" @blur="getDataUpdate" type="Number" :disabled="!item.editable">
      </el-input>
    </div>
    <div v-if="item.uiType === 3">
      <div class="listGroup">
        <el-select v-model="value" size="mini" filterable clearable placeholder="" style="width: 100%"
          :disabled="!item.editable" @change="getDataUpdate">
          <el-option v-for="item in item.options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button size="mini" @click="getSearchPage" v-if="showBtn">
          <i class="el-icon-search searchIcon"></i>
        </el-button>
      </div>
    </div>
    <div v-if="item.uiType === 4" class="listGroup">
      <el-select v-model="value" size="mini" filterable clearable multiple placeholder="" style="width: 100%"
        :disabled="!item.editable" @change="getDataUpdate">
        <el-option v-for="item in item.listEntry" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button size="mini" @click="getSearchPage" v-if="showBtn">
        <i class="el-icon-search searchIcon"></i>
      </el-button>
    </div>
    <!-- <div v-if="item.uiType === 6">
            <DatePicker :type="item.type || ''" :value="value" :disabled="!item.editable" @onChange="onDateChange" />
        </div> -->

    <div v-if="item.uiType === 19">
      <el-switch v-model="value"> </el-switch>
    </div>

    <!-- <el-dialog v-dialogDrag title="搜索" :modal="false" class="simple-dialog" :visible.sync="searchDialog"
        v-if="searchDialog">
        <rl-table :Rltable="tableData" :tHeight="420" @rowdbClick="handleClick" />
      </el-dialog> -->
  </div>
</template>

<script>
// import DatePicker from "@/components/common/DatePicker.vue";
// import { useUTCDate } from "@/utils";
// import { NON_SEARCH_LIST_FIELDS, } from "@/utils/Costant";

export default {
  props: ["data"],
  // components: { DatePicker, },
  data() {
    return {
      options: [],
      value: "",
      baseVal: "",
      item: {},
      searchDialog: false,
      tableData: [],
      searchFinish: false,
    };
  },
  computed: {
    showBtn() {
      return false;
      // return !NON_SEARCH_LIST_FIELDS.includes(this.data.listId);
    },
  },
  watch: {
    data(val) {
      this.item = val;
    },
  },
  created() {
    this.item = this.data;
    this.value = this.data.val;
    this.baseVal = this.value;
  },
  methods: {
    handleClick(val) {
      console.log(val);
      const { listId, entryId } = val;
      const n = listId;
      if (this.data.uiType === 3) {
        this.value = n;
      } else if (this.data.uiType === 4) {
        if (!this.value.includes(n)) this.value.push(n);
      }
      this.searchDialog = false;
      this.getDataUpdate();
    },
    onDateChange(v) {
      console.log(v);
      const value = useUTCDate(v);
      this.value = value;
      this.item.val = value;
      this.$emit("change", this.item);
    },
    getDataUpdate() {
      this.item.val = this.value;
      this.$emit("change", this.item);
    },
    // async getSearchPage() {
    //     if (this.searchFinish) {
    //         this.searchDialog = true;
    //         return;
    //     }
    //     const res = await axiosService.get("/pmdm/admin/list/getEnabledListEntryByListId?listId=" + this.data.listId);
    //     const { listEntries } = res.data.object;
    //     const col = [
    //         { prop: "entryValue", label: this.$t("message.table.name") },
    //         { prop: "description", label: this.$t("message.table.des") },
    //     ];
    //     this.tableData = [col, listEntries];
    //     this.searchDialog = true;
    //     this.searchFinish = true;
    // },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input--mini .el-input__inner {
  // height: 40px;
  // line-height: 40px;
  // border-radius: 6px;
}

.mydropdown {
  overflow: auto; // 添加滚动条
  max-height: 200px; // 最大高度
  overflow-x: hidden; // 隐藏x轴上的滚动条
}

.searchIcon {
  color: #353ecb;
}

.temp {
  border: #dd5a5d 1px dashed;
  box-sizing: border-box;
}

input::placeholder {
  color: #dd5a5d;
}

.listGroup {
  display: flex;
  gap: 0.4em;
}
</style>
